import { useModelTuningGetApi, useSiteGetApi } from '@/common/api/modules/site'
import { useSiteId } from '@/common/app/site'

import Content from '@/components/view/layouts/page/Content'
import Main from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import ModelTuningForm from '@/components/container/form/modules/recommend/modelTuning/ModelTuningForm'
import AppTitleBadge from '@/components/container/layout/AppTitleBadge'
import TrainingHistoryModalProvider from '@/components/container/modal/trainingHistory/TrainingHistoryModalProvider'

const ModelTuningPage = () => {
  const siteId = useSiteId()

  const {
    data: tuningData,
    mutate: mutateTuning,
    isLoading: isTuningLoading
  } = useModelTuningGetApi({ site_id: siteId })
  const { data: siteData } = useSiteGetApi({ site_id: siteId })

  // 全サイトが W2Commerce 完全連動
  const isW2Full = true

  if (isTuningLoading || !tuningData) {
    return (
      <Main>
        <PageTitle title='モデルチューニング' badgeNode={<AppTitleBadge type='recommend' />} />
        <Content>
          <PageListLoading />
        </Content>
      </Main>
    )
  }

  return (
    <TrainingHistoryModalProvider>
      <Main>
        <ModelTuningForm
          tuningData={tuningData}
          siteId={siteId}
          isW2Full={isW2Full}
          mutateTuning={mutateTuning}
        />
      </Main>
    </TrainingHistoryModalProvider>
  )
}

export default ModelTuningPage
